import React from "react";
import { colors, fonts } from "../../theme";
import GlobalLink from "../GlobalLink";
import { createStyles, withStyles, Divider, List, ListItem, CircularProgress } from "@material-ui/core";
import { buildAddOnTestsQuery } from "../../utils/AddOnTestHelper";
import { FavoriteBorder, Publish } from "@material-ui/icons";
import TabBar from "../../components/TabBar";
var styles = function styles(theme) {
  return createStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      borderRadius: "1px",
      fontSize: "12px",
      color: colors.lightGrey,
      backgroundColor: colors.seaShell,
      minWidth: "155px",
      maxWidth: "265px",
      textAlign: "left",
      wordWrap: "break-word",
      overflow: "hidden",
      overflowWrap: "break-word"
    },
    header: {
      fontWeight: 700,
      borderBottom: "3px solid ".concat(colors.seaShell),
      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
      paddingLeft: theme.spacing(1),
      paddingTop: "5px",
      color: colors.lightGrey
    },
    content: {
      padding: "5px 0",
      "&:hover": {
        fontWeight: 800
      }
    },
    innerContainer: {
      display: "flex",
      flexDirection: "column",
      borderRadius: "10px",
      fontSize: fonts.sizes.xxs,
      fontWeight: 400,
      color: colors.lightGrey,
      backgroundColor: colors.white,
      margin: theme.spacing(1),
      padding: "0px 0px 8px 0px"
    },
    testSectionHeader: {
      fontWeight: 500
      //   padding: theme.spacing(1, 0),
    },
    testSection: {
      padding: "5px 0",
      "&:hover": {
        fontWeight: 800
      },
      marginLeft: theme.spacing(1)
    },
    manifestDivider: {
      height: "3px"
    },
    iconAndLabel: {
      display: "flex",
      alignItems: "left"
    },
    iconText: {
      marginLeft: theme.spacing(1)
    },
    divider: {
      height: "0px",
      border: "1px solid rgba(241, 241, 241, 1)",
      width: "265px",
      marginLeft: -theme.spacing(1),
      marginRight: -theme.spacing(1)
    },
    flexContainer: {
      justifyContent: "flex-start"
    },
    notFoundContainer: {
      display: "flex",
      flexDirection: "column",
      minWidth: "155px",
      maxWidth: "265px",
      borderRadius: "10px",
      fontSize: fonts.sizes.xxs,
      fontWeight: 400,
      color: colors.lightGrey,
      backgroundColor: colors.white,
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: theme.spacing(3),
      margin: "0px 24px",
      minHeight: "120px"
    },
    tabRoot: {
      minWidth: "50%",
      flex: "initial",
      textTransform: "none",
      "&.Mui-selected": {
        color: "#28A8E0",
        fontWeight: "bold",
        backgroundColor: colors.white,
        borderRadius: "10px 0px 0px 10px",
        "&.Mui-selected img": {
          filter: "invert(45%) sepia(70%) saturate(300%) hue-rotate(160deg)"
        }
      },
      "&:not(.Mui-selected)": {
        backgroundColor: "#eaeaea",
        color: colors.lightGrey
      }
    },
    noElevation: {
      "& .MuiPaper-elevation4": {
        boxShadow: "none !important"
      }
    },
    tabIndication: {
      display: "none"
    }
  });
};
var PANELS = ["favorites", "tests"];
var getHeader = function getHeader(header, headerUrl) {
  return headerUrl ? React.createElement("a", {
    href: headerUrl
  }, header) : header;
};
var VAOverlay = function VAOverlay(_ref) {
  var tests = _ref.tests,
    header = _ref.header,
    headerUrl = _ref.headerUrl,
    urlPrefix = _ref.urlPrefix,
    institutionCode = _ref.institutionCode,
    classes = _ref.classes,
    loading = _ref.loading,
    favoriteTests = _ref.favoriteTests;
  // Purpose for both renderTestSection, renderFavoriteTestSection is to generate URL for tests having type BriefTestInfo and BaseTestDTO respectively.
  var renderTestSection = function renderTestSection(testInfo) {
    // Added a function to generate URL for tests having type BriefTestInfo
    var url = function url(test) {
      // Generate URL based on displayTestCode and code
      var result = "".concat(urlPrefix).concat(test.displayTestCode && test.displayTestCode.toLowerCase() !== "none" ? "".concat(test.displayTestCode, "&ctc=").concat(test.code) : test.code);
      var createOrderAddOnTestCodes = window.appConfig.createOrderAddOnTests.find(function (x) {
        return x.testCode === test.code && institutionCode && x.hospitalCodes.includes(institutionCode);
      });
      if (createOrderAddOnTestCodes && createOrderAddOnTestCodes.addOnTests.length > 0) {
        result = "".concat(result, ",").concat(buildAddOnTestsQuery(createOrderAddOnTestCodes.addOnTests));
      }
      return "".concat(result, "&new-cart=true");
    };
    return React.createElement(React.Fragment, null, testInfo.testType && React.createElement("text", {
      className: classes.testSectionHeader
    }, testInfo.testType), testInfo.tests.map(function (tc) {
      return React.createElement(ListItem, {
        button: true,
        component: GlobalLink,
        to: url(tc),
        key: "".concat(tc.code)
      }, tc.testName);
    }));
  };
  // Added a function to generate URL for tests having type BaseTestDTO
  var renderFavoriteTestSection = function renderFavoriteTestSection(test) {
    var result = "".concat(urlPrefix).concat(test.displayTestCode && test.displayTestCode.toLowerCase() !== "none" ? "".concat(test.displayTestCode, "&ctc=").concat(test.code) : test.code);
    var createOrderAddOnTestCodes = window.appConfig.createOrderAddOnTests.find(function (x) {
      return x.testCode === test.code && institutionCode && x.hospitalCodes.includes(institutionCode);
    });
    if (createOrderAddOnTestCodes && createOrderAddOnTestCodes.addOnTests.length > 0) {
      result = "".concat(result, ",").concat(buildAddOnTestsQuery(createOrderAddOnTestCodes.addOnTests));
    }
    var url = "".concat(result, "&new-cart=true");
    return React.createElement(ListItem, {
      button: true,
      component: GlobalLink,
      to: url,
      key: test.code
    }, test.name);
  };
  var renderPanel = function renderPanel(panel) {
    switch (panel) {
      case "favorites":
        if (loading) {
          return React.createElement("div", {
            className: classes.notFoundContainer
          }, React.createElement(CircularProgress, {
            size: 24,
            style: {
              color: "#28A8E0"
            }
          }), React.createElement("div", {
            style: {
              marginTop: 8
            }
          }, "Loading favorites..."));
        }
        if (!favoriteTests || favoriteTests.length === 0) {
          return React.createElement("div", {
            className: classes.notFoundContainer
          }, "No favorite tests available");
        }
        return React.createElement(List, null, favoriteTests.map(function (favoriteTest) {
          return renderFavoriteTestSection(favoriteTest);
        }));
      case "tests":
        return React.createElement(List, null, tests.map(function (test) {
          return renderTestSection(test);
        }));
      default:
        return React.createElement(React.Fragment, null);
    }
  };
  function capitalizeFirst(word) {
    return word.charAt(0).toUpperCase() + word.slice(1);
  }
  var panelTabContent = PANELS.map(function (panelName, index) {
    return {
      content: renderPanel(panelName) || React.createElement(React.Fragment, null),
      index: index,
      label: panelName === "favorites" ? React.createElement("span", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 4
        }
      }, React.createElement(FavoriteBorder, {
        fontSize: "small"
      }), capitalizeFirst(panelName)) : React.createElement("span", {
        style: {
          display: "flex",
          alignItems: "center",
          gap: 4
        }
      }, React.createElement("img", {
        src: "/images/test-tube-icon.svg",
        width: "20",
        height: "20"
      }), capitalizeFirst(panelName))
    };
  });
  // this will need to be revisited if we include customers that will want VOB, but not want to upload a manifest for VOB
  var canUploadManifest = Boolean(window.appConfig.features.isCUHKManifestUploadEnabled) && institutionCode === "CUHK";
  return React.createElement("div", {
    className: classes.container
  }, React.createElement("div", {
    className: classes.header
  }, getHeader(header, headerUrl)), React.createElement("div", {
    className: classes.innerContainer
  }, canUploadManifest && React.createElement(React.Fragment, null, React.createElement(GlobalLink, {
    className: classes.testSection,
    to: "/create/manifest",
    key: "manifest-upload",
    tooltipTitle: "Click to create orders by CSV"
  }, React.createElement("div", {
    className: classes.iconAndLabel
  }, React.createElement(Publish, null), React.createElement("span", {
    className: classes.iconText
  }, "Upload Manifest"))), React.createElement(Divider, {
    className: classes.manifestDivider
  })), React.createElement("div", {
    className: classes.noElevation
  }, React.createElement(TabBar, {
    tabs: panelTabContent,
    defaultTabIndex: 1,
    classes: {
      flexContainer: classes.flexContainer,
      tab: classes.tabRoot,
      tabIndication: classes.tabIndication
    }
  }))));
};
export default withStyles(styles)(VAOverlay);